// extracted by mini-css-extract-plugin
export default {"mainDiv":"ForgotPass_mainDiv__fyykz","logoImage":"ForgotPass_logoImage__M0VDW","mainLogo":"ForgotPass_mainLogo__u2PWP","mainInput":"ForgotPass_mainInput__GEwQ6"};